<div class="At-ViewProfile">
  <div class="At-ViewProfileContent">
    <figure class="At-ProfileImage">
      <img src="assets/images/profile/profile-image.jpg" alt="Profile Image">
    </figure>
    <div class="At-Status">
      <form>
        <label>Set Your Status</label>
        <div class="At-Select">
          <select class="form-control">
            <option>Active</option>
            <option>Disactive</option>
          </select>
        </div>
      </form>
    </div>
    <div class="At-Infoarea">
      <div class="At-InfoText">
        <p>Phone Number</p>
        <h5>+1 554 7854</h5>
      </div>
      <div class="At-InfoText">
        <p>Bio</p>
        <h5>Lorem ipsum dolor sit amet, consectur adiping elit, sed do eiusmod tempor incididunt </h5>
      </div>
      <div class="At-InfoText">
        <p>Location</p>
        <h5>NewYork, USA</h5>
      </div>
      <div class="At-InfoText">
        <p class="At-Font16 mb-4">Channels in common</p>
        <div class="At-InfoBox">
          <div class="At-InfoImg">
            <figure class="At-FigureText At-BgRed">
              <h4>GM</h4>
            </figure>
          </div>
          <div class="At-InfoTitle d-flex">
            <div class="At-TitleLeft">
              <h5 class="At-Font2rem">general meeting </h5>
              <h6><span class="At-Font17">08 Members</span></h6>
            </div>
          </div>
        </div>
        <div class="At-InfoBox">
          <div class="At-InfoImg">
            <figure class="At-FigureText At-BgGreen">
              <h4>DF</h4>
            </figure>
          </div>
          <div class="At-InfoTitle d-flex">
            <div class="At-TitleLeft">
              <h5 class="At-Font2rem">designs feedbacks </h5>
              <h6><span class="At-Font17">08 Members</span></h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
